import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import ChevronRight from '@mui/icons-material/ChevronRight'
import { ActivitiesListItemInfo } from './ActivitiesListItemInfo'
import { useHandlers } from './hooks'
import type { Activity } from '../../../typings'

type Props = {
  id: number
  activity: Activity
}

export function ActivitiesListItem(props: Props) {
  const { activity, id } = props
  const { handleShowActivity } = useHandlers(props)

  return (
    <Box width="100%" boxSizing="content-box" mx={-1.6} my={-0.8} flex={1}>
      <Button fullWidth>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
          onClick={handleShowActivity}
          px={1.6}
          py={0.8}
          minHeight="64px"
          data-test-id={`activity-list-item-${id}`}
        >
          <ActivitiesListItemInfo activity={activity} />
          <ChevronRight />
        </Stack>
      </Button>
    </Box>
  )
}
